import React, { useState, useEffect } from 'react'
import Pagination from 'rc-pagination'
import ReportTable from './components/reportTable'
import { getSubcnMonthReport } from '../../../api/cn'
import styles from './styles.scss'

const MonthForm = ({ cns, months }) => {

  const columns = [
    { title: '代理商名称', dataIndex: 'name', key: 'name' },
    // { title: '分类', dataIndex: 'type', key: 'type' },
    { title: '渠道码', dataIndex: 'code', key: 'code' },
    { title: '省市区', dataIndex: 'area', key: 'area' },
    { title: '成交订单数', dataIndex: 'orderNum', key: 'orderNum' },
    { title: '单笔佣金', dataIndex: 'commission', key: 'commission' },
    { title: '总佣金', dataIndex: 'totalCommission', key: 'totalCommission' },
    { title: '手续费', dataIndex: 'fee', key: 'fee' },
    { title: '税费', dataIndex: 'taxes', key: 'taxes' },
    { title: '实际结算金额', dataIndex: 'account', key: 'account' }
  ]

  const [month, setMonth] = useState(months[0])
  const [cn, setCN] = useState(cns[0])
  const [reportData, setReportData] = useState([])
  const [totalOrder, setTotalOrder] = useState(0)
  const [account, setAccount] = useState(0)
  const [userNum, setUserNum] = useState(0)

  useEffect(() => {
    handleSearch()
  }, [month, cn])

  const handleMonthChange = e => {
    const item = e.target.options[e.target.options.selectedIndex]
    setMonth({ label: item.label, value: item.value })
  }

  const handleSearch = () => {
    const params = {
      month: month.value,
      cn: cn.value
    }
    getSubcnMonthReport(params, { quiet: true }).then(res => {
      if (!!res) {
        const data = res.map(item => ({
          name: item.channel.name,
          code: item.channel.code,
          area: item.channel.area,
          orderNum: item.order_num,
          commission: item.commission,
          totalCommission: (Number(item.commission) * item.order_num).toFixed(2),
          fee: (Number(item.fee) * item.order_num).toFixed(2),
          taxes: (Number(item.taxes) * item.order_num).toFixed(2),
          account: (Number(item.commission - item.fee - item.taxes) * item.order_num ).toFixed(2)
        }))
        const totalOrder = data.reduce((prev, item) => prev + Number(item.orderNum), 0)
        const totalAccount = data.reduce((prev, item) => prev + Number(item.account), 0)
        const totalUser = res.reduce((prev, item) => prev + Number(item.user_num), 0)
        setReportData(data)
        setTotalOrder(totalOrder)
        setAccount(totalAccount.toFixed(2))
        setUserNum(totalUser)
      }
    })
  }

  const handleExport = () => { }

  return (
    <div className={styles.forms}>
      <div className={styles.filter}>
        <select value={month.value} onChange={handleMonthChange}>
          {
            months.map(item => (
              <option key={item.value} value={item.value}>{item.label}</option>
            ))
          }
        </select>
      </div>
      <div className={styles.total}>
        <div className={styles.summary}>
          <span>结算订单总数: {totalOrder}</span>
          <span>结算总金额: {account}元</span>
          <span>当月注册数: {userNum}</span>
        </div>
        {/*<button className={styles.changeBtn} onClick={handleExport}>导出</button>*/}
      </div>
      <ReportTable columns={columns} dataSource={reportData} />
    </div>
  )
}

export default MonthForm
